import React, { useState, useEffect } from 'react';
import MaskedInput from 'antd-mask-input';

import { LockOutlined, PixOutlined, CreditCard, PhoneOutlined, CalendarMonthOutlined, CurrencyExchangeTwoTone} from '@mui/icons-material/';

import { Grid, FormControlLabel, Box } from '@material-ui/core';
import { CustomRadio } from './styles';
import Proximo from '@assets/Login/proximo.png';

import { Form, Input, Spin, Radio, Select as SelectAntd} from 'antd';

import Agradecimento from '@src/pages/Agradecimento';

import DoadorMirim from '@src/pages/RecadoDoadorMirim';

import { PayPalButton } from 'react-paypal-button';
import { Button } from '@material-ui/core';
import Button2 from '@components/Shared/Buttons/Button';



import ButtonComponent from '@components/Shared/Buttons/Button';

import { TitlePage, SubTitle, InterTitle} from '@styles/styles.global';
import InvisibleContent from '@components/Shared/InvisibleContent';

import '@styles/AntStyles.css';
import { addDays } from 'date-fns';

import MultiProgress from 'react-multi-progress';

import UFs from '@components/Shared/BuscaEstados/UF2.json';

import Service, {
  IRequestCreatePessoa, IRequestCreatePessoaCredito, IRequestCreatePessoaDebito
} from './services';
import { MaskCPFeCNPJ } from '@utils/Masks';
import { validaCPFandCNPJ } from '@utils/Validators';
import SearchCEPCorreios from '@utils/SearchCEPCorreios';


import { mdiBarcodeScan } from '@mdi/js';
import Icon from '@mdi/react';
import useDebounce from '@hooks/useDebounce';

const DATA = addDays(new Date(), 0).toISOString().split('T')[0];

const progressoPix = 7;
const progressoBoleto = 9;
const progressoCC = 15;
const progressoDA = 15;

interface IEstado {
  id: string | number;
  label: string;
}

interface IConvenio {
  id: number;
  descricao: string;
}

interface IOperacao {
  id: number;
  descricao: string;
  codigo_operacao: string;
}

const Principal: React.FC = () => {

  const [formPessoaRef] = Form.useForm();
  const [formPessoaRefPaypal] = Form.useForm();

  const [loadingCreatePessoaCredito, setLoadingCreatePessoaCredito] = useState(false);
  const [loadingCreatePessoaPix, setLoadingCreatePessoaPix] = useState(false);
  const [loadingCreatePessoaBoleto, setLoadingCreatePessoaBoleto] = useState(false);
  const [loadingCreatePessoaDebito, setLoadingCreatePessoaDebito] = useState(false);
  const [loadingCreatePessoaTeste, setLoadingCreatePessoaTeste] = useState(false);

  const [loading, setLoading] = useState(false);
  const [valorDoacao, setValorDoacao] = useState(false);

  const [formaContribPix, setFormaContribPix] = useState(false);
  const [formaContribCredito, setFormaContribCredito] = useState(false);
  const [formaContribBoleto, setFormaContribBoleto] = useState(false);
  const [formaContribDebito, setFormaContribDebito] = useState(false);


  const [tipoDocumento, setTipoDocumento] = useState<'pf' | 'pj'>('pf');

  const [valorModifyValorDebito, setValorModifyValorDebito] =
  useState<string>('');

  const [campo1, setCampo1] =useState<number>(0);
  const [campo2, setCampo2] = useState<number>(0);
  const [campo3, setCampo3] = useState<number>(0);
  const [campo4, setCampo4] = useState<number>(0);
  const [campo5, setCampo5] = useState<number>(0);
  const [campo6, setCampo6] = useState<number>(0);
  const [campo7, setCampo7] = useState<number>(0);

  const [campo8, setCampo8] = useState<number>(0);
  const [campo9, setCampo9] = useState<number>(0);

  const [campo10, setCampo10] = useState<number>(0);
  const [campo11, setCampo11] = useState<number>(0);
  const [campo12, setCampo12] = useState<number>(0);
  const [campo13, setCampo13] = useState<number>(0);
  const [campo14, setCampo14] = useState<number>(0);
  const [campo15, setCampo15] = useState<number>(0);

  const [campo16, setCampo16] = useState<number>(0);
  const [campo17, setCampo17] = useState<number>(0);
  const [campo18, setCampo18] = useState<number>(0);
  const [campo19, setCampo19] = useState<number>(0);
  const [campo20, setCampo20] = useState<number>(0);
  const [campo21, setCampo21] = useState<number>(0);

  const [fraseDoacao1, setFraseDoacao1] = useState(false);
  const [fraseDoacao2, setFraseDoacao2] = useState(false);
  const [fraseDoacao3, setFraseDoacao3] = useState(false);
  const [fraseDoacao4, setFraseDoacao4] = useState(false);
  const [fraseDoacao5, setFraseDoacao5] = useState(false);
  const [fraseDoacao6, setFraseDoacao6] = useState(false);
  const [fraseDoacao7, setFraseDoacao7] = useState(false);
  const [fraseDoacao8, setFraseDoacao8] = useState(false);
  const [fraseDoacao9, setFraseDoacao9] = useState(false);
  const [fraseDoacao10, setFraseDoacao10] = useState(false);
  const [fraseDoacao11, setFraseDoacao11] = useState(false);

  const [confDadosPessoais, setConfDadosPessoais] = useState(false);
  const [confDadosValorFormaPag, setConfDadosValorFormaPag] = useState(false);

  const [valorDoacaoInputResposta, setValorDoacaoInputResposta] = useState('');
  const [valorDoacaoInput, setValorDoacaoInput] = useState('');

  const [loadingCEP, setLoadingCEP] = useState(false);
  const [uf, setUF] = useState<any>();
  const [checked, setChecked] = useState(true);
  const [loadingCEP2, setLoadingCEP2] = useState(false);
  const [suggestionsEstado, setSuggestionsEstado] = useState<IEstado[]>(
    UFs.UF,
  );

  const [etapa, setEtapa] = useState(4);

  const step1 = (campo1 + campo2 + campo3 + campo4 + campo5 + campo6 + campo7) / progressoPix;
  const step2 = (campo1 + campo2 + campo3 + campo4 + campo5 + campo6 + campo7 + campo8 + campo9) / progressoBoleto;
  const step3 = (campo1 + campo2 + campo3 + campo4 + campo5 + campo6 + campo7 + campo8 + campo9 + campo10 + campo11 +
    campo12 + campo13 + campo14 + campo15) / progressoCC;

  const step4 = (campo1 + campo2 + campo3 + campo4 + campo5 + campo6 + campo7 + campo8 + campo9 + campo16 +
    campo17 + campo18 + campo19 + campo20 + campo21) / progressoDA;

  const [openAgradecimento, setAgradecimento] = useState(false);

  const [novoLayout, setNovoLayout] = useState(false);
  const [paypal, setPaypal] = useState(true);

  const [convenioSelecionada, setConvenioSelecionada] =
    useState('');

  const [dataNasc, setDataNasc] = useState(false);

  const [convenio, setConvenio] = useState<IConvenio[]>([
    { id: 2, descricao: 'BANCO DO BRASIL' },
    { id: 6, descricao: 'BANCO SANTANDER S.A.' },
    { id: 7, descricao: 'BANCO BRADESCO S.A.' },
    { id: 8, descricao: 'CAIXA ECONOMICA FEDERAL' },
    { id: 9, descricao: 'BANCO ITAÚ UNIBANCO S.A.' },
  ]);

  const [operacaoCaixa, setOperacaoCaixa] = useState<IOperacao[]>([
    { id: 1, descricao: 'Cta. Corrente - P.Física', codigo_operacao: '001' },
    { id: 2, descricao: 'Cta. Simples - P.Física', codigo_operacao: '002' },
    { id: 3, descricao: 'Cta. Corrente - P.Jurídica', codigo_operacao: '003' },
    { id: 4, descricao: 'Entidades Públicas', codigo_operacao: '006' },
    { id: 5, descricao: 'Dep. Inst. Financeiras', codigo_operacao: '007' },
    { id: 6, descricao: 'Consignação em pagamento', codigo_operacao: '011' },
    { id: 7, descricao: 'Poupança - P.Física', codigo_operacao: '013' },
    { id: 8, descricao: 'Conta Benefício', codigo_operacao: '018' },
    { id: 9, descricao: 'Poupança - P.Jurídica', codigo_operacao: '022' },
    { id: 10, descricao: 'Conta Eletrônica', codigo_operacao: '023' },
    { id: 11, descricao: 'Poupança-Créd Imobiliário', codigo_operacao: '028' },
    { id: 12, descricao: 'Dep. Lotéricos', codigo_operacao: '043' },
  ]);

  const [operacaoSantander, setOperacaoSantamder] = useState<IOperacao[]>([
    { id: 13, descricao: 'Operação 001', codigo_operacao: '001' },
    { id: 14, descricao: 'Operação 002', codigo_operacao: '002' },
    { id: 15, descricao: 'Operação 003', codigo_operacao: '003' },
    { id: 16, descricao: 'Operação 005', codigo_operacao: '005' },
    { id: 17, descricao: 'Conta salário', codigo_operacao: '060' },
    { id: 18, descricao: 'Poupança', codigo_operacao: '071' },
    { id: 19, descricao: 'Cta. Corrente - P.Física', codigo_operacao: '092' },
  ]);


  const filterCheckTipoConvenio = (descricao: any) => {
    const forma = convenio.filter(x => x.descricao === descricao);

    if (forma.length > 0) setConvenioSelecionada(forma[0].descricao);
  };

  const HandleChangeEtapa = (value: number) => {
    setEtapa(value);
  };


  function handleInput(e: any) {
    var ss = e.target.selectionStart;
    var se = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.selectionStart = ss;
    e.target.selectionEnd = se;
  };

  const validarData = (data: string) => {
    const [dia, mes, ano] = data.split('/').map(Number);
    const dataValida = new Date(ano, mes - 1, dia);

    return (
      dataValida.getFullYear() === ano &&
      dataValida.getMonth() === mes - 1 &&
      dataValida.getDate() === dia
    );
  };


  async function onSubmitTeste(values: any) {

    setLoadingCreatePessoaTeste(true);
    setLoading(true);
    console.log(values);

    const services = new Service();
    const createPessoaCredito: IRequestCreatePessoaCredito = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === undefined
        ?false
        :true,
        boleto: values.boleto === false,
        pix: values.pix  === false,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: values.cep,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      },
      cartao: {
        number: values.number,
        verification_value: values.verification_value,
        first_name: values.first_name,
        last_name: values.last_name,
        month: values.month,
        year: values.year,
      }
    };

    console.log('entrou aqui')


    setLoadingCreatePessoaTeste(false);

    //window.location.reload();

   // console.log('efjdlkf0', loadingCreatePessoaTeste);
  }

  async function onSubmitCredito(values: any) {

    setLoadingCreatePessoaCredito(true);
    setLoading(true);
    console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaCredito: IRequestCreatePessoaCredito = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === undefined
        ?false
        :true,
        boleto: values.boleto === false,
        pix: values.pix  === false,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      },
      cartao: {
        number: values.number,
        verification_value: values.verification_value,
        first_name: values.first_name,
        last_name: values.last_name,
        month: values.month,
        year: values.year,
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoaCredito(createPessoaCredito);

    if (!error) {
      //window.alert("Cadastrado com sucesso! O Santuário Pai Eterno agradece sua doação!!");
      await(setAgradecimento(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");

    }

    setLoadingCreatePessoaCredito(false);

    //window.location.reload();
  }

   async function onSubmitPix(values: any) {

    setLoadingCreatePessoaPix(true);
    setLoading(true);
    console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaPix: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: values.boleto === false,
        pix: values.pix === undefined
        ?false
        :true,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaPix);

    if (!error) {
      window.location.assign(response);
      await(setAgradecimento(true));


    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setAgradecimento(true));
    }

    setLoadingCreatePessoaPix(false);

    //window.location.reload();
  }

  async function onSubmitPixUnica(values: any) {

    setLoadingCreatePessoaPix(true);
    setLoading(true);
    console.log(values);

    const services = new Service();

    //teste

    const createPessoaPix: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: values.boleto === false,
        pix: values.pix === undefined
        ?false
        :true,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: values.cep,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaPix);

    if (!error) {
      window.location.assign(response);
      await(setAgradecimento(true));


    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");
      //await(setAgradecimento(true));
    }

    setLoadingCreatePessoaPix(false);

    //window.location.reload();
  }

  async function onSubmitBoleto(values: any){

    setLoadingCreatePessoaBoleto(true);
    setLoading(true);
    console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaBoleto: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: values.boleto === undefined
        ?false
        :true,
        pix: values.pix === false,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaBoleto);

    if (!error) {
      window.location.assign(response);
      await(setAgradecimento(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");

    }

    setLoadingCreatePessoaBoleto(false);

    //window.location.reload();
  }


  async function onSubmitBoletoUnica(values: any){

    setLoadingCreatePessoaBoleto(true);
    setLoading(true);
    console.log(values);

    const services = new Service();



    const createPessoaBoleto: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      doacao: {
        valor: parseInt(valorModifyValorDebito),

        cartao: values.cartao === false,
        boleto: values.boleto === undefined
        ?false
        :true,
        pix: values.pix === false,
        recorrente: checked,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: values.cep,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoa(createPessoaBoleto);

    if (!error) {
      window.location.assign(response);
      await(setAgradecimento(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");

    }

    setLoadingCreatePessoaBoleto(false);

    //window.location.reload();
  }

  async function onSubmitDebito(values: any){

    setLoadingCreatePessoaDebito(true);
    setLoading(true);
    console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }
    const cepLimpo = limparValor(values.cep);

    const createPessoaDebito: IRequestCreatePessoaDebito = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha:{
        descricao: 'teste',
      },
      debito_automatico: {
        convenio: values.convenio,
        vencimento: values.vencimento,
        numero_agencia: values.numero_agencia,
        digito_agencia: values.digito_agencia,
        numero_conta: values.numero_conta,
        digito_conta: values.digito_conta,
        operacao: values.operacao,
        valor: parseInt(valorModifyValorDebito),
      }
    };

    console.log('entrou aqui')

    const { error, response } = await services.CreatePessoaDebito(createPessoaDebito);

    if (!error) {
      //window.open(response);
      await(setAgradecimento(true));

    } else {
      window.alert( "Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!");

    }

    setLoadingCreatePessoaDebito(false);

    //window.location.reload();
  }

  const searchCEPDebounce = async (value: string) => {
    const searchCEPCorreios = new SearchCEPCorreios();

    setLoadingCEP(true);
    const { error, response } = await searchCEPCorreios.SearchCEP(value);
    setLoadingCEP2(true);
    setLoadingCEP(false);
    if (!error && response) {
      setUF(response.uf);
      formPessoaRef.setFieldsValue({
        descricao: response.logradouro,
        bairro: response.bairro,
        uf: response.uf,
        cidade: response.localidade,
      });
    }
  };

  const debounceCEP = useDebounce(searchCEPDebounce, 800);

  const onChangeDocumento = (e: any) => {
    const value = e.target.value;

    const { typeDocument, valueModify } = MaskCPFeCNPJ(value);

    setTipoDocumento(typeDocument);

    formPessoaRef.setFieldsValue({
      cpfcnpj: valueModify,
    });

    if (typeDocument === 'pj') {
      formPessoaRef.setFieldsValue({
        sexo: 1,
      });
    }
  };

  const validaDocumento = (_: any, val: any) => {
    const documentoExiste = validaCPFandCNPJ(val);

    if (documentoExiste) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Digite um documento válido'));
  };


  async function compararValorDoacao(valor: any){
    setValorDoacaoInputResposta('');

    if (valor < 5){
      setValorDoacaoInputResposta('Valor mínimo a ser doado R$ 5');
      //console.log('TESTE', valor)
      //console.log('TESTE', valorDoacaoInputResposta)
      //setFraseDoacao6(false);
      setFraseDoacao7(false);
      setFraseDoacao8(false);
      setFraseDoacao9(false);
      setFraseDoacao10(false);
      setFraseDoacao11(false);
      console.log("entrou aquiiiiii")
    }

    if (valor === '20' || valor === '40' || valor === '80'){
         setValorDoacaoInputResposta('Digite um valor difente dos pré definidos: "20 40 80"')
         //setFraseDoacao6(false);
         setFraseDoacao7(false);
         setFraseDoacao8(false);
         setFraseDoacao9(false);
         setFraseDoacao10(false);
         setFraseDoacao11(false);
         console.log("entrou aquiiiiii2222")
    }
  }

  const createArrayRange = (
    start: number,
    increment: number,
    length: number,
  ) => {
    let array = [];

    for (let i = start; i <= length; i += increment) {
      array.push(i);
    }

    return array;
  };

  const [valorPaypal1, setValorPaypal1] =useState<number>(0);
  const [valorPaypal2, setValorPaypal2] =useState<number>(0);
  const [valorPaypal3, setValorPaypal3] =useState<number>(0);
  const [valorPaypal4, setValorPaypal4] =useState<number>(0);
  const [valorPaypal5, setValorPaypal5] =useState<number>(0);


  const onApprove = async () => {
    window.location.reload();
      await(setAgradecimento(true));
}

  const backgroundImage = 'https://www.paieterno.com.br/wp-content/uploads/2025/03/tela-doacao.png';


  async function teste2(data_nascimento: Date){

    const dataCompleta = data_nascimento.toString();
    const dataConvertida = dataCompleta.split('/').reverse().join('-');

    var date1 = new Date(dataConvertida);
    var date2 = new Date();

    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays < 6574 ){
      setDataNasc(true);
      console.log ('MENOR DE 18');

    }else{

      setDataNasc(false);
      console.log ('MAIOR QUE 18');
    }

    //console.log(diffDays+ " dias");
  }
  console.log("resposras", valorDoacaoInputResposta)

  return (
    <>
      <Grid container>

        <InvisibleContent visible={paypal === true}>
          <Grid container style={{ display: etapa === 4 ? 'flex' : 'none' }}>
            <div
              style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                minHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Conteúdo Central */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                {/* Imagens */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <img
                    src={'https://www.paieterno.com.br/wp-content/uploads/2025/03/2.png'}
                    style={{ width: 150, height: 86 }}
                    alt="Imagem 1"
                  />
                    <img
                      src={'https://www.paieterno.com.br/wp-content/uploads/2025/03/logo-pai-eterno.png'}
                      style={{ width: 80, height: 85, marginTop: '19px' }}
                      alt="Logo Pai Eterno"
                    />
                </div>

                <Form
                form={formPessoaRefPaypal}
                size="middle"
                layout="vertical"
                scrollToFirstError={true}
                //onFinish={onSubmitCredito}
                labelAlign="left"
                labelCol={{
                  span: 50,
                }}
                wrapperCol={{
                  span: 50,
                }}
                requiredMark={false}
                initialValues={{
                  nome: '',
                  cpfcnpj: '',
                  email: '',
                  descricao: '',
                  numero: '',
                  complemento: '',
                  bairro: '',
                  cidade: '',
                  cep: '',
                  uf: '',
                }}
              >

                <Grid container item lg={12} sm={12} xs={12}  alignItems="center" justify="center" >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p style={{fontSize: '24px', color:'#0e4159', fontWeight: 'bold', marginBottom: '0em'}}>
                      Doação Paypal
                    </p>
                    <p style={{fontSize: '16px', color:'#0e4159', marginBottom: 0}}>
                      Selecione o valor da doação:
                    </p>
                  </div>
                </Grid>


                <Grid container item lg={12} sm={12} xs={12}  alignItems="center" justify="center" >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 20, background:'#f0f0f0', border: '2px solid #ddd', padding: 10 }}>


                  <Grid container item lg={12} sm={12} xs={12} alignItems="center" justify="center" >
                        <Form.Item
                          name='valorDoacao1'
                          rules={[
                            {required: true, message: '*Campo obrigatório' },
                          ]}
                        >

                          <Grid>
                            <Form.Item name="valor1" >
                              <Radio.Group>
                                <Grid container item  lg={12} sm={12} xs={12} justify="center" alignItems="center" >
                                  <Grid item container justify="center" alignItems="center" lg={3} sm={3} md={6} xs={6} style={{ paddingTop: 5}}>
                                    <Form.Item>
                                      <Radio.Button value={20} onClick={(e: any) => {setValorDoacao(e); setValorDoacaoInput('')}} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setFraseDoacao6(true); compararValorDoacao(e.target.value); setValorDoacaoInputResposta(''); setValorPaypal1(e.target.value); setFraseDoacao7(false); setFraseDoacao8(false); setFraseDoacao9(false); setFraseDoacao10(false)}} >
                                        R$ 20
                                      </Radio.Button>
                                    </Form.Item>
                                  </Grid>

                                  <Grid item container justify="center" alignItems="center" lg={3} sm={3} md={6} xs={6} style={{ paddingTop: 5}}>
                                    <Form.Item>
                                      <Radio.Button value={40} onClick={(e: any) => {setValorDoacao(e); setValorDoacaoInput('')}} onChange={(e: any) => {setValorModifyValorDebito(e.target.value);  setFraseDoacao7(true); compararValorDoacao(e.target.value); setValorDoacaoInputResposta(''); setValorPaypal2(e.target.value); setFraseDoacao6(false); setFraseDoacao8(false); setFraseDoacao9(false); setFraseDoacao10(false)}} >
                                        R$ 40
                                      </Radio.Button>
                                    </Form.Item>
                                  </Grid>


                                  <Grid item container justify="center" alignItems="center" lg={3} sm={3} md={6} xs={6} style={{ paddingTop: 5}}>
                                    <Form.Item>
                                      <Radio.Button value={60} onClick={(e: any) => {setValorDoacao(e); setValorDoacaoInput('')}} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setFraseDoacao8(true); compararValorDoacao(e.target.value); setValorDoacaoInputResposta(''); setValorPaypal3(e.target.value); setFraseDoacao6(false); setFraseDoacao7(false); setFraseDoacao9(false); setFraseDoacao10(false)}} >
                                        R$ 60
                                      </Radio.Button>
                                    </Form.Item>
                                  </Grid>

                                  <Grid item container justify="center" alignItems="center" lg={3} sm={3} md={6} xs={6} style={{ paddingTop: 5}}>
                                    <Form.Item>
                                      <Radio.Button value={90} onClick={(e: any) => {setValorDoacao(e); setValorDoacaoInput('')}} onChange={(e: any) => {setValorModifyValorDebito(e.target.value); setFraseDoacao9(true); compararValorDoacao(e.target.value); setValorDoacaoInputResposta(''); setValorPaypal4(e.target.value); setFraseDoacao6(false); setFraseDoacao7(false); setFraseDoacao8(false); setFraseDoacao10(false) }} >
                                        R$ 90
                                      </Radio.Button>
                                    </Form.Item>
                                  </Grid>

                                </Grid >

                                <InvisibleContent visible={valorDoacao != true}>

                                  <Grid style={{paddingTop: 11}}>


                                      <Grid container justify="center" >
                                        <Grid item lg={12} sm={12} xs={12}>
                                          <Form.Item
                                            //label='Doar outro valor'
                                          >
                                            <Radio.Button
                                              value={''}
                                              style={{ textAlign: 'left', fontSize: 16, color: '#c1c1c1' ,background: '#f9f9f9', width: '100%', height: 40, borderRadius: 4, border: '1px solid #ddd', paddingTop: 5}}
                                              onChange={(e: any) => {setValorDoacao(true);}}
                                            >
                                              Deseja doar outro valor? Digite aqui
                                            </Radio.Button>
                                          </Form.Item>
                                        </Grid>

                                    </Grid>
                                  </Grid>
                                </InvisibleContent>
                              </Radio.Group>

                              <InvisibleContent visible={valorDoacao === true}>

                                <Grid style={{paddingTop: 11}}>


                                    <Grid container justify="center" >
                                      <Grid item lg={12} sm={12} xs={12}>
                                        <Form.Item
                                        //label='Doar outro valor'
                                          rules={[
                                            {pattern: /^[0-9]+$/, message: 'Por favor digite somente números!'},
                                          ]}
                                        >
                                          <InvisibleContent visible={valorDoacaoInputResposta === ''}>
                                          <Input
                                            style={{ fontSize: 16}}
                                            type={"number"}
                                            value={valorDoacaoInput}
                                            //defaultValue={valorDoacaoInput}
                                            inputMode='numeric'
                                            placeholder='Deseja doar outro valor? Digite aqui'
                                            onChange={(e: any) => {
                                              setValorModifyValorDebito(e.target.value);
                                              setValorPaypal5(e.target.value);
                                              setFraseDoacao10(true); setFraseDoacao7(false); setFraseDoacao8(false); setFraseDoacao9(false); setFraseDoacao6(false)
                                              compararValorDoacao(e.target.value);
                                              setValorDoacaoInput(e.target.value)


                                            }}
                                          />
                                          </InvisibleContent>

                                          <InvisibleContent visible={valorDoacaoInputResposta != ''}>
                                          <Input
                                            style={{ fontSize: 16, borderColor: '#ff4d4f'}}
                                            type={"number"}
                                            value={valorDoacaoInput}
                                            //defaultValue={valorDoacaoInput}
                                            inputMode='numeric'
                                            placeholder='Deseja doar outro valor? Digite aqui'
                                            onChange={(e: any) => {
                                              setValorModifyValorDebito(e.target.value);
                                              setFraseDoacao10(true);
                                              compararValorDoacao(e.target.value);
                                              setValorDoacaoInput(e.target.value)
                                              setValorPaypal5(e.target.value);

                                            }}
                                          />
                                          </InvisibleContent>

                                        </Form.Item>
                                      </Grid>

                                  </Grid>
                                  <p style={{color: "#ff4d4f"} }>
                                    {valorDoacaoInputResposta}
                                  </p>
                                </Grid>
                              </InvisibleContent>
                            </Form.Item>
                          </Grid>
                        </Form.Item>
                      </Grid>

                  </div>

                </Grid>

                <InvisibleContent visible={fraseDoacao6 === false && fraseDoacao7 === false && fraseDoacao8 === false && fraseDoacao9 === false && fraseDoacao10 === false}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 49}}>
                        <Form
                          form={formPessoaRefPaypal}
                          scrollToFirstError={true}
                          onFinish={onSubmitTeste}
                        >
                          <ButtonComponent
                            color="secondary"
                            //loading={loadingCreatePessoaTeste}
                            type='submit'
                            style={{height: 65, width: 200, fontSize: 16, paddingLeft: 10}}
                            //onClick ={() => HandleChangeEtapa(3)}
                          >
                            Continuar
                            <img src={Proximo} style={{ height: 40, width: 40, marginLeft: 10}} />
                          </ButtonComponent>
                        </Form>
                      </Grid>
                    </InvisibleContent>


                    <InvisibleContent visible={fraseDoacao6 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>

                             <PayPalButton
                          paypalOptions={{clientId: "ARVLCG-WqFr-hLHxHyTmUzjKyX08L3zHVS4RfBlNoYvBekEJoSqssxj1D7FaJ884Y4XN5Gv6IbcrgT_a", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{layout: 'horizontal',
                          shape: 'pill', tagline: false, label: "paypal", color: "gold"}}
                          amount={valorPaypal1}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao7 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>

                             <PayPalButton
                          paypalOptions={{clientId: "ARVLCG-WqFr-hLHxHyTmUzjKyX08L3zHVS4RfBlNoYvBekEJoSqssxj1D7FaJ884Y4XN5Gv6IbcrgT_a", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{layout: 'horizontal',
                          shape: 'pill', tagline: true, label: "paypal", color: "gold"}}
                          amount={valorPaypal2}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao8 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>

                             <PayPalButton
                          paypalOptions={{clientId: "ARVLCG-WqFr-hLHxHyTmUzjKyX08L3zHVS4RfBlNoYvBekEJoSqssxj1D7FaJ884Y4XN5Gv6IbcrgT_a", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{layout: 'horizontal',
                          shape: 'pill', tagline: true, label: "paypal", color: "gold"}}
                          amount={valorPaypal3}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao9 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>

                             <PayPalButton
                          paypalOptions={{clientId: "ARVLCG-WqFr-hLHxHyTmUzjKyX08L3zHVS4RfBlNoYvBekEJoSqssxj1D7FaJ884Y4XN5Gv6IbcrgT_a", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{layout: 'horizontal',
                          shape: 'pill', tagline: true, label: "paypal", color: "gold"}}
                          amount={valorPaypal4}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    <InvisibleContent visible={fraseDoacao10 === true}>
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 55}}>


                             <PayPalButton
                          paypalOptions={{clientId: "ARVLCG-WqFr-hLHxHyTmUzjKyX08L3zHVS4RfBlNoYvBekEJoSqssxj1D7FaJ884Y4XN5Gv6IbcrgT_a", intent: 'capture', currency: "BRL", }}
                          buttonStyles={{layout: 'horizontal',
                          shape: 'pill', tagline: true, label: "paypal", color: "gold"}}
                          amount={valorPaypal5}
                          onPaymentSuccess={onApprove}
                        />



                      </Grid>
                    </InvisibleContent>

                    </Form>

                {/* Botão Voltar */}
                <Button2
                            color='default'
                            onClick={() => { window.location.href = '/';}}
                            style={{color: '#000', fontSize: '16px', backgroundColor: 'transparent'}}
                          >
                            Voltar
                          </Button2>
              </div>
            </div>
          </Grid>
        </InvisibleContent>





      {/* --------------------------- AGRADECIMENTO ----------------------------- */}
        <InvisibleContent visible={openAgradecimento === true}>
          <Agradecimento/>
        </InvisibleContent>



       {/* --------------------------- DOADOR MIRIM ----------------------------- */}
       <InvisibleContent visible={dataNasc === true}>
          <DoadorMirim/>
        </InvisibleContent>


        {/* --------------------------- RODAPÉ 2 ----------------------------- */}


        <Grid container>
                <Grid container alignItems="center" justify="center" item lg={12} sm={12} xs={12} style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 35 }} >




                <Grid container item lg={7} md={7} sm={7} xs={8} alignItems="center" justifyContent="center">
                  <a href="https://wa.me/556235069800" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <PhoneOutlined style={{ marginTop: 3, height: 17, marginRight: 8, color: '#999' }} />
                    <strong style={{fontSize: 17, color: '#333', textAlign:'center'}}>Central de Relacionamento: </strong>
                    <div style={{ height: '20px' }}></div>
                    <strong style={{textDecoration: 'underline',  textAlign:'center'}}>(62) 3506-9800</strong>
                  </a>
                </Grid>


                </Grid>
              </Grid>

        <Grid item lg={12} sm={12} xs={12} style={{paddingTop: 40}}>
          <Grid container alignItems="center" justify="center"
            style={{backgroundColor: '#fcf7f7', paddingTop: 10, paddingBottom: 10}}
          >
            <Grid container item lg={8} sm={8} xs={12} alignItems="center" justify="center" >
              <TitlePage style={{fontSize: 14, color:'#333'}}>Desenvolvido por  </TitlePage>
              <img src={'https://amex-arquivos.s3.sa-east-1.amazonaws.com/sociallis-logoPng.png'} style={{paddingLeft:10, width: 140 }} />
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    </>

  );
};

export default Principal;
